<template>
    <div>
        <b-row>
            <b-col>
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col class="mb-2">
                                <strong>
                                    Demonstrativo Sintético (F028/05)
                                </strong>
                                <strong v-if="$temAcessoView('GESCON-FORN-CONV-00')" class="fa fa-paper-plane fa-lg icon-button ml-2"
                                    @click="EnviarDocumentoParaAssinador('F02805')" title="Enviar para Portal de Assinatura"></strong>
                                <strong class="fa fa-print fa-lg icon-button ml-2" 
                                    @click.stop="emitirRelatorio('F02805')" title="Emitir Relatório (F28/05)"></strong>
                            </b-col>
                            <b-col>
                                <strong>
                                    Relatório de Pagamentos SEBRAE (F028/06)
                                </strong>
                                <strong v-if="$temAcessoView('GESCON-FORN-CONV-00')" class="fa fa-paper-plane fa-lg icon-button ml-2" 
                                    @click="EnviarDocumentoParaAssinador('F02806')" title="Enviar para Portal de Assinatura"></strong>
                                <strong class="fa fa-print fa-lg icon-button ml-2" 
                                    @click.stop="emitirRelatorio('F02806')" title="Emitir Relatório (F28/06)"></strong>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mb-2">
                                <strong>
                                    Rel de Pagamentos Parceiros (F028/07)
                                </strong>
                                <strong v-if="$temAcessoView('GESCON-FORN-CONV-00')" class="fa fa-paper-plane fa-lg icon-button ml-2"
                                    @click="EnviarDocumentoParaAssinador('F02807')" title="Enviar para Portal de Assinatura"></strong>
                                <strong class="fa fa-print fa-lg icon-button ml-2"
                                    @click.stop="emitirRelatorio('F02807')" title="Emitir Relatório (F28/07)"></strong>
                            </b-col>
                            <b-col>
                                <strong>
                                    Rel Despesas Econômicas Parceiros (F028/08)
                                </strong>
                                <strong v-if="$temAcessoView('GESCON-FORN-CONV-00')" class="fa fa-paper-plane fa-lg icon-button ml-2"
                                    @click="EnviarDocumentoParaAssinador('F02808')" title="Enviar para Portal de Assinatura"></strong>
                                <strong class="fa fa-print fa-lg icon-button ml-2"
                                    @click.stop="emitirRelatorio('F02808')" title="Emitir Relatório (F28/08)"></strong>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>
                                    Rel de Compras e Contratações (F028/09)
                                </strong>
                                <strong v-if="$temAcessoView('GESCON-FORN-CONV-00')" class="fa fa-paper-plane fa-lg icon-button ml-2"
                                    @click="EnviarDocumentoParaAssinador('F02809')" title="Enviar para Portal de Assinatura"></strong>
                                <strong class="fa fa-print fa-lg icon-button ml-2"
                                    @click.stop="emitirRelatorio('F02809')" title="Emitir Relatório (F28/09)"></strong>
                            </b-col>
                           <b-col>
                            <div></div>
                                <strong>
                                    Declaração de Atesto
                                </strong>
                                <strong v-if="$temAcessoView('GESCON-FORN-CONV-00')"  class="fa fa-paper-plane fa-lg icon-button ml-2"
                                    @click="EnviarDocumentoParaAssinador('F02810')" title="Enviar para Portal de Assinatura"></strong>
                                <strong class="fa fa-print fa-lg icon-button ml-2"
                                    @click.stop="emitirRelatorio('F02810')" title="Emitir Declaração de Atesto"></strong>
                            </b-col>
                            
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-modal id="modalDoc" size="xl" v-model="mostrarModal" no-close-on-backdrop style="height: 50%; margin: 0">
            <div slot="modal-title">Visualizar Documentos - {{ nomeDoc }}</div>
            <iframe v-if="arquivo" v-bind:src="arquivo" style="width: 100%; height: 600px">
            </iframe>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    props: {
        convenio: {
            type: Object
        },
        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
            arquivo: null,
            nomeDoc: ''
        }
    },

    methods: {
        EnviarDocumentoParaAssinador(codRelatorio) {
            this.$store.dispatch('addRequest')
            this.dataServicos.EnviarDocumentoParaAssinador(
                this.convenio.idConvenio,
                codRelatorio
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            `Documento ${codRelatorio} Enviado Para Portal de Assinatura com Successo! `,
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(
                            'Erro ao enviar relatório !!!',
                            'ERROR',
                            this.$toastConfig.error
                        )   
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        emitirRelatorio(codigoRelatorio) {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterRelatorio(this.convenio.idConvenio, codigoRelatorio)
                .then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao emitir relatório!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.visualizar(response, `Relatório ${codigoRelatorio}`)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        visualizar(doc, nome) {
            this.nomeDoc = nome
            const blob = new Blob([doc], { type: 'application/pdf' })
            this.arquivo = window.URL.createObjectURL(blob)
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        }
    }
}
</script>